import axiosInstance from '../config/axios.js';

const API_BASE = '/ei-receipts';

const eiReceiptService = {
  // Get all EI receipts with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all EI receipts without pagination
  getAllReceipts: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get client published EI receipts (for clients)
  getClientReceipts: async (clientId, page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      client_id: clientId,
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/client`, { params: queryParams });
    return response.data;
  },

  // Get EI receipt by ID
  getById: async (receiptId) => {
    const response = await axiosInstance.get(`${API_BASE}/${receiptId}`);
    return response.data;
  },

  // Create new EI receipt
  create: async (receiptData) => {
    const response = await axiosInstance.post(API_BASE, receiptData);
    return response.data;
  },

  // Update EI receipt
  update: async (receiptId, receiptData) => {
    const response = await axiosInstance.put(`${API_BASE}/${receiptId}`, receiptData);
    return response.data;
  },

  // Toggle published status
  togglePublished: async (receiptId) => {
    const response = await axiosInstance.patch(`${API_BASE}/${receiptId}/toggle-published`);
    return response.data;
  },

  // Delete EI receipt
  delete: async (receiptId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${receiptId}`);
    return response.data;
  },

  // Download EI receipt PDF
  downloadPDF: async (receiptId) => {
    const response = await axiosInstance.get(`${API_BASE}/${receiptId}/download`, {
      responseType: 'blob'
    });
    return response;
  },

  // Get pending receipts for DM
  getPendingForDM: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(`${API_BASE}/pending-for-dm`, { params: queryParams });
    return response.data;
  },

  // Send bulk email for selected receipts
  sendBulkEmail: async (receiptIds) => {
    const response = await axiosInstance.post(`${API_BASE}/send-bulk-email`, {
      ids: receiptIds
    });
    return response.data;
  },

  // Download bulk PDFs for selected receipts (single PDF or ZIP)
  downloadBulkPDF: async (receiptIds) => {
    const response = await axiosInstance.post(`${API_BASE}/bulk-pdf-download`, {
      ids: receiptIds
    }, {
      responseType: 'blob'
    });
    return response;
  },

  // Export CSV for selected receipts
  exportCSV: async (receiptIds) => {
    const response = await axiosInstance.post(`${API_BASE}/export-csv`, {
      ids: receiptIds
    }, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Duplicate an EI receipt record
  duplicate: async (receiptId) => {
    const response = await axiosInstance.post(`${API_BASE}/${receiptId}/duplicate`);
    return response.data;
  },
};

export default eiReceiptService;